/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Dresses(props) {
    return (
        <SvgIcon {...props}>
            <path d="M10.823,7.955H7.29L7.131,6.872C6.29,7.244,5.519,7.385,4.861,7.385c-0.912,0-1.605-0.245-2.001-0.429 c-0.121,0.881-0.849,6.221-0.875,6.429c0.326,0,3.112-0.026,3.112-0.026l0.139,0.063c0.118,0.051,0.328,0.121,0.328,0.121 l0.966-4.354l0.806,0.205L6.39,13.764l1.641,0.231V9.454h0.842V14l1.656-0.271L9.583,9.349l0.891-0.219l0.933,4.346L12,13.291 L10.823,7.955z" />
            <path d="M2.848,5.979c0.313,0.185,1.994,1.059,4.264-0.048l0.029-1.299c0,0,0.88,0.536,0.987,0.593 C8.261,5.058,9.58,3.248,9.676,3.116C9.483,2.974,6.922,1.117,6.922,1.117C6.789,1.001,6.789,1.006,6.57,1.001H5.817 c-0.155,0-0.299,0.058-0.412,0.162L4.894,1.695L4.302,1.168C4.19,1.064,4.045,1.001,3.885,1.001H3.18 c-0.23,0-0.203-0.026-0.39,0.142c0,0-2.704,2.299-2.791,2.379c0.086,0.104,1.499,1.62,1.613,1.72 c0.105-0.037,1.152-0.653,1.152-0.653L2.848,5.979z" />
        </SvgIcon>
    );
}

Dresses.defaultProps = {
    viewBox: '0 0 12 16'
};

export default Dresses;
